export const colors = {
  white: '#FFFFFF',
  black: '#000000',

  disabledSurface: 'rgba(18, 21, 23, 0.08)',
  disabledFill: 'rgba(18, 21, 23, 0.16)',
  disabledContent: 'rgba(18, 21, 23, 0.32)',
  layerOverlay: 'rgba(22, 22, 20, 0.56)',

  titan25: '#FAFAF8',
  titan50: '#F4F5F0',
  titan100: '#EEEFE9',
  titan200: '#E1E3DA',
  titan250: '#d8d9d0',
  titan300: '#C8C9C1',
  titan400: '#A2A399',
  titan500: '#888a7d',
  titan600: '#64665a',
  titan700: '#5D5E56',
  titan800: '#32332F',
  titan900: '#161614',
  titan1000: '#030303',

  coldGrey25: '#F9FAFB',
  coldGrey50: '#F3F4F5',
  coldGrey100: '#EEF0F1',
  coldGrey200: '#E1E4E6',
  coldGrey250: '#D7DDE0',
  coldGrey300: '#B8C3C8',
  coldGrey400: '#95A0A6',
  coldGrey500: '#808B90',
  coldGrey550: '#677278',
  coldGrey600: '#5f676b',
  coldGrey700: '#535C61',
  coldGrey800: '#2C3134',
  coldGrey900: '#121517',
  coldGrey1000: '#030304',

  warmGrey25: '#FBFAF9',
  warmGrey50: '#F7F4F2',
  warmGrey100: '#F3EFEC',
  warmGrey200: '#E8E2DF',
  warmGrey250: '#d9cec7',
  warmGrey300: '#CCC2BB',
  warmGrey400: '#afa298',
  warmGrey500: '#98897f',
  warmGrey600: '#70645b',
  warmGrey700: '#635850',
  warmGrey800: '#37322e',
  warmGrey900: '#181513',
  warmGrey1000: '#050302',

  yellowFrontRow25: '#F8FEE1',
  yellowFrontRow50: '#EEFEAE',
  yellowFrontRow100: '#E3FF00',
  yellowFrontRow200: '#DBF601',
  yellowFrontRow300: '#BBD307',
  yellowFrontRow400: '#9DB104',
  yellowFrontRow500: '#869705',
  yellowFrontRow600: '#647101',
  yellowFrontRow700: '#596503',
  yellowFrontRow800: '#303701',
  yellowFrontRow900: '#151900',
  yellowFrontRow1000: '#030400',

  neonFrontRow25: '#F8FEE1',
  neonFrontRow50: '#EEFEAE',
  neonFrontRow100: '#E3FF00',
  neonFrontRow200: '#D5F001',
  neonFrontRow300: '#BBD307',
  neonFrontRow400: '#9DB104',
  neonFrontRow500: '#869705',
  neonFrontRow600: '#626F00',
  neonFrontRow700: '#596503',
  neonFrontRow800: '#303701',
  neonFrontRow900: '#151900',

  error25: '#FDF9F9',
  error50: '#FBF2F1',
  error100: '#FAEBE9',
  error200: '#F9DDDA',
  error300: '#F9AEA5',
  error400: '#FA766C',
  error500: '#F93436',
  error550: '#ED0A0E',
  error600: '#C11A21',
  error700: '#AB161C',
  error800: '#63080C',
  error900: '#300303',

  success25: '#F3FDF5',
  success50: '#E4FCE7',
  success100: '#D4FBDA',
  success200: '#ADFABC',
  success300: '#38E873',
  success400: '#1CC45C',
  success500: '#15A84D',
  success600: '#10893E',
  success700: '#0A7132',
  success800: '#043E19',
  success900: '#021C08',

  burgundy25: '#FCF9FA',
  burgundy50: '#F9F2F4',
  burgundy100: '#F7ECEE',
  burgundy200: '#F3DFE3',
  burgundy300: '#E9B3C0',
  burgundy400: '#E1849E',
  burgundy500: '#D95A83',
  burgundy600: '#A44362',
  burgundy700: '#84344E',
  burgundy800: '#531E2F',
  burgundy900: '#270B14',
  burgundy1000: '#080203',

  celery25: '#F5FDF5',
  celery50: '#E8FAE6',
  celery100: '#DAF9D8',
  celery200: '#BBF7B8',
  celery300: '#60E561',
  celery400: '#4ECF50',
  celery500: '#3DA53F',
  celery600: '#29772A',
  celery700: '#266F28',
  celery800: '#123D12',
  celery900: '#051C05',

  violet25: '#F9FAFD',
  violet50: '#F3F3FC',
  violet100: '#EDEEFB',
  violet200: '#E0E2FB',
  violet300: '#ACAFFF',
  violet400: '#9697FF',
  violet500: '#7D75FF',
  violet600: '#5F2EFE',
  violet700: '#5702F5',
  violet800: '#2F018E',
  violet900: '#140148',

  cyan25: '#F6FBFD',
  cyan50: '#EAF7FB',
  cyan100: '#DEF3FA',
  cyan200: '#C4EDF9',
  cyan300: '#57D7F8',
  cyan400: '#33C5E8',
  cyan500: '#249BB8',
  cyan600: '#0F7087',
  cyan700: '#15687C',
  cyan800: '#083945',
  cyan900: '#031920',

  purple25: '#FBF9FD',
  purple50: '#F6F2FB',
  purple100: '#F2ECFB',
  purple200: '#EADFFA',
  purple300: '#CCA4FD',
  purple400: '#BE83FE',
  purple500: '#AE57FE',
  purple600: '#8E03E2',
  purple700: '#7F03CB',
  purple800: '#470274',
  purple900: '#210139',

  pink25: '#FDF9FA',
  pink50: '#FCF1F4',
  pink100: '#FCEAEF',
  pink200: '#FBDAE5',
  pink300: '#FF95BD',
  pink400: '#FF66A7',
  pink500: '#F90290',
  pink600: '#BD016C',
  pink700: '#A90260',
  pink800: '#600134',
  pink900: '#2F0017',

  teal25: '#F2FDFC',
  teal50: '#DEFBF8',
  teal100: '#CCFAF6',
  teal200: '#9AF9F1',
  teal300: '#50DDD4',
  teal400: '#3FC9C1',
  teal500: '#2F9F99',
  teal600: '#05756E',
  teal700: '#1C6B66',
  teal800: '#0C3B38',
  teal900: '#041A19',

  orange25: '#FFF5F0',
  orange50: '#FFF0E8',
  orange100: '#FFDBC7',
  orange200: '#FFB88F',
  orange300: '#FF792B',
  orange400: '#EB5E00',
  orange500: '#BA4400',
  orange600: '#913800',
  orange700: '#5E2200',
  orange800: '#3E1400',
  orange900: '#261100',

  blue25: '#F8FAFD',
  blue50: '#EFF5FB',
  blue100: '#E7F0FA',
  blue200: '#D5E7F9',
  blue300: '#78BBFA',
  blue400: '#52ABF9',
  blue500: '#2091E8',
  blue600: '#116AAD',
  blue700: '#12619E',
  blue800: '#05355A',
  blue900: '#02172B',

  magenta25: '#FDF8FD',
  magenta50: '#FBF0FA',
  magenta100: '#FAE9F9',
  magenta200: '#F8D9F6',
  magenta300: '#F592F3',
  magenta400: '#F259F3',
  magenta500: '#D73AD8',
  magenta600: '#A22AA3',
  magenta700: '#912492',
  magenta800: '#521052',
  magenta900: '#270527',

  notice25: '#FDFAF3',
  notice50: '#FCF3E3',
  notice100: '#FCEDD5',
  notice200: '#FCE1B3',
  notice300: '#FFB800',
  notice400: '#D49905',
  notice500: '#B58202',
  notice600: '#825F00',
  notice700: '#7A5601',
  notice800: '#442F01',
  notice900: '#201400',

  info25: '#F9FAFD',
  info50: '#F1F4FB',
  info100: '#EAEFFB',
  info200: '#DBE5FB',
  info250: '#C2D0F2',
  info300: '#ABC3FC',
  info400: '#80A3FF',
  info500: '#6189FF',
  info600: '#3250FA',
  info700: '#1E00FF',
  info800: '#0E009E',
  info900: '#030250',

  yellow25: '#FDFAEF',
  yellow50: '#FCF4D9',
  yellow100: '#FBEFC4',
  yellow200: '#FBE493',
  yellow300: '#D7B300',
  yellow400: '#C3A204',
  yellow500: '#A68A01',
  yellow600: '#7A6400',
  yellow700: '#705C01',
  yellow800: '#3E3201',
  yellow900: '#1C1500',
} as const;
